import { setRange } from './helpers';

export const setBedrooms = setRange('bedroom_total');
